"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import NetworkServicesTabs from "@/components/pageTabs/networkServicesTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import AdvantageComp from "./components/advantages";
import ComparisonComp from "./components/comparsion";
import ServiceByOneMind from "./components/serviceByOneMind";
import Solutions from "./components/solutions";
import DCIGraphicImg from "./components/dciGraphic";
import ConnectionGraphicImg from "./components/connectionGraphic";

const InternetAndDCIPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <NetworkServicesTabs />
        <Box>
          <Intro />
          <AdvantageComp />
          <DCIGraphicImg />
        </Box>
        <ServiceByOneMind />
      </PageLayout>
      <ComparisonComp />
      <PageLayout showContactForm>
        <ConnectionGraphicImg />
        <Solutions />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default InternetAndDCIPage;
